export default {
  DarkPurple: '#2b2a4c',
  BlueGrey: '#7577a2',
  BlueGrey2: '#7577a1',
  BlueGrey3: '#dcdaf2',
  Pink: '#e92c81',
  BlackRussian: '#1b1c32',
  White: '#ffffff',
  Blue: '#235dd4',
  Purple: '#876fe9',
  MidnightNavy: '#343457',
  MidnightBlue: '#1d327a',
  Jacarta: '#3c2a67',
  LightGreyBlue: '#92afd6',
  SkyBlue: '#7ba5fb',
  azul: '#2162e3',
  Dusk: '#556080',
  Dusk2: '#525175',
  Dusk3: '#3b3d6b',
  Dusk4: '#4b4d77',
  VibrantGreen: '#0ccc06',
  Green: '#11bc1f',
  GreyBlue2: '#7d94b4',
  Greyish: '#b9b9b9',
  UglyPurple: '#aa3c7f',
  PaleGrey: '#f5f4fa',
  GreyishBrown: '#515151',
  PaleGrey2: '#f5f4f9',
  MarineBlue: '#002e5b',
  Black2: '#292929',
  DarkSlateBlue: '#231d67',
  WarmGrey: '#888888',
  WarmGrey2: '#9d9d9d',
  OrangeYellow: '#ffa201',
  Cerise: '#d4198b',
  PinkishGrey: '#bcbcbc',
  Red: '#FF3333',
  Nero: '#1b1b1b',
  NightRider: '#2b2b2b',
  LightPink: '#f1e0ec',
  DarkBlue: '#242a55',
  DarkBlue1: '#303a6d',
  DarkBlue2: '#038afd',
  PattensBlue: '#cedbef',
  Sapphire: '#06082a',
  DodgerBlue: '#0394FC',
  DodgerBlue1: '#008AFD',
  RegalBlue: '#182152',
  WildStrawberry: '#FF2A82',
  JacksonsPurple: '#434E85',
  JacksonsPurple1: '#3A447B',
  Lime: '#00CD00',
  DarkTangerine: '#FF9A14',
  WildBlueYonder: '#7689B4',
  PersianBlue: '#21339f',
  Bunker: '#1d1f20',
  Manatee: '#8993A8',
  BrilliantRose: '#ff4893',
  newBackground: '#242a55',
  link: '#008afd',
  disable: '#7689b4',
  stoneWall: '#7d879f',
  WaikawaGrey: '#697490',
  paleBlue: '#c4c9d3',
  solitude: '#e9eef5',
  linkWater: '#c4cdde',
  error: '#ff6f60',
  charcoal: '#707070',
  Cherokee: '#ffcb87',
  muzliColor: '#b8d2fb',
  darkNavy: '#000225',
  midnight: '#050937',
  sunflowerYellow: '#ffcc00'
};
